<div class="container-fluid">
  <div class="row">
    <nav class="main-menu col-md-2 d-none d-md-block bg-white" [ngClass]="{'nav-list-open': true}">
      <div class="side-bar-item" *ngFor="let item of itemList">
        <li>
          <a
            (click)="!isDisabled(item) && selectItem(item)"
            [ngClass]="{'selected': isSelected(item), 'not-expanded': !isSelected(item), 'disabled-item': isDisabled(item)}">
            <span class="nav-text">{{ item.label }}</span>
          </a>
        </li>
      </div>
    </nav>
    <div class="col-md-10 offset-md-2 content-area">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
